"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradeEnvoys = void 0;
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var Size_1 = require("../render/Size");
var TradeEnvoys = (function (_super) {
    __extends(TradeEnvoys, _super);
    function TradeEnvoys() {
        return _super.call(this, {
            cost: 6,
            name: CardName_1.CardName.TRADE_ENVOYS,
            cardType: CardType_1.CardType.ACTIVE,
            metadata: {
                cardNumber: 'C46',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.effect('When you trade, you may first increase that Colony Tile track 1 step.', function (eb) {
                        eb.trade().startEffect.text('+1', Size_1.Size.LARGE);
                    });
                }),
            },
        }) || this;
    }
    TradeEnvoys.prototype.play = function (player) {
        player.colonyTradeOffset++;
        return undefined;
    };
    TradeEnvoys.prototype.onDiscard = function (player) {
        player.colonyTradeOffset--;
    };
    return TradeEnvoys;
}(Card_1.Card));
exports.TradeEnvoys = TradeEnvoys;
//# sourceMappingURL=TradeEnvoys.js.map